/**
 * 德育管理-日常评价v1.0
 * 后端技术方案: https://note.youdao.com/s/Qm6OgLiW
 * 接口文档地址：http://gitlab.10niu.cn/organization/repository/editor?id=21&mod=94&itf=3833
 *
 * 后端技术方案: https://note.youdao.com/s/4vID0c7a
 * 接口文档地址：http://gitlab.10niu.cn/organization/repository/editor?id=21&mod=579&itf=3823
 *
 * 德育管理-日常评价v1.1
 * 后端技术方案: https://note.youdao.com/s/cpuuiwlb
 * 接口文档地址：http://gitlab.10niu.cn/repository/editor?id=21&mod=579&itf=3868
 */
import requestByGateway from '@/request/request.gateway';
import qs from 'qs';
import config from '@/config';

const dailyEvaluation = {
	// 新版后台_获取学校职工管理的班级年级列表
	//【该接口 是给职工获取对应的年级班级使用的】
	getGradeClassList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/user/get_grade_class_list`,
			headers: config.headers,
			params
		});
	},
	// 新版后台_获取学校职工关联的班级年级id
	//【该接口 是给五育并举管理员使用的】
	getGradeClass(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/user/get_grade_class`,
			headers: config.headers,
			params
		});
	},
	// 后台_成长指标体系_添加一二级分类指标
	addClassificationIndicators(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moral-education/add_classification_indicators`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_成长指标体系_编辑一二级分类指标
	editClassificationIndicators(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moral-education/edit_classification_indicators`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_成长指标体系_删除分类指标
	deleteClassificationIndicators(data) {
		return requestByGateway({
			method: 'post',
			url: `${
				config.api.admin
			}/moral-education/delete_classification_indicators`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_成长指标体系_获取一二级分类指标列表
	getClassificationIndicatorsList(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.admin
			}/moral-education/get_classification_indicators_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_成长指标体系_添加三级分类指标
	addClassificationIndicatorsDetail(data) {
		return requestByGateway({
			method: 'post',
			url: `${
				config.api.admin
			}/moral-education/add_classification_indicators_detail`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_成长指标体系_编辑三级分类指标
	editClassificationIndicatorsDetail(data) {
		return requestByGateway({
			method: 'post',
			url: `${
				config.api.admin
			}/moral-education/edit_classification_indicators_detail`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_成长指标体系_获取三级分类指标
	getAllClassificationIndicatorsDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.admin
			}/moral-education/get_all_classification_indicators_detail`,
			headers: config.headers,
			params
		});
	},
	// 后台_成长指标体系_分页获取三级分类指标列表
	getClassificationIndicatorsDetailList(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.admin
			}/moral-education/get_classification_indicators_detail_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_成长指标体系_获取三级级分类指标详情
	getOneClassificationIndicatorsDetail(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				config.api.admin
			}/moral-education/get_one_classification_indicators_detail`,
			headers: config.headers,
			params
		});
	},
	// 后台_日常评价_获取学生评分列表
	getStudentScoreList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_student_score_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_日常评价_评价学生
	editStudentcore(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/moral-education/edit_student_score`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_数据中心_获取学校评价数据
	getSchoolEvaluateSummary(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_school_evaluate_summary`,
			headers: config.headers,
			params
		});
	},
	// 后台_数据中心_获取学校一级分类总分数据
	getSchoolScoreSummary(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_school_score_summary`,
			headers: config.headers,
			params
		});
	},
	// 后台_数据中心_获取年级总分
	getGradeClassScoreSummary(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_grade_class_score_summary`,
			headers: config.headers,
			params
		});
	},
	// 后台_数据中心_获取学生分数汇总
	getStudentScoreSummary(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_student_score_summary`,
			headers: config.headers,
			params
		});
	},
	// 后台_表现评价_获取学生评价详情成长记录
	getStudentGrowthRecord(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_student_growth_record`,
			headers: config.headers,
			params
		});
	},
	// 后台_表现评价_获取学生评价详情成长轨迹
	getStudentGrowthTrack(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/moral-education/get_student_growth_track`,
			headers: config.headers,
			params
		});
	}
};

export default dailyEvaluation;
